import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { AIMedia } from '../../@types';

type Payload = {
  aiMediaId: string;
};

const getAiGenerationStatus = async (payload: Payload): Promise<AIMedia> => {
  const res = await axiosInstance.post('/api/stock-gallery/get-status', payload);
  return res.data;
};

export const useGetAiGenerationStatus = () => {
  return useMutation(getAiGenerationStatus, { onSuccess: (data) => data });
};
